import React from 'react'

const Bisnis = () => {
  return (
    <div>Bisnis</div>
  )
}

export default Bisnis